module.exports = __webpack_public_path__ + "img/961837133.d463406c.jpg";